import { CHANGE_ATTRIBUTE_NAME_MAP, NO_RECENT_LEAVE_CHANGES_MESSAGE } from "./constants.js";
import { hasInErrorReason } from "./helpers.js";
class LeaveChanges {
    constructor() {
        this.format = (response) => {
            const searchResultMetadata = this._extractSearchMetadata(response);
            const leaves = [];
            if (!response.leaves || !Array.isArray(response.leaves)) {
                return {
                    searchResultMetadata,
                    LeaveSearch: leaves
                };
            }
            response.leaves.forEach((leave) => {
                const leavePeriods = Array.isArray(leave.leavePeriod)
                    ? leave.leavePeriod
                    : [];
                if (Array.isArray(leave.recentChanges)) {
                    leave.recentChanges.forEach((change) => {
                        const period = leavePeriods.find((leavePeriod) => leavePeriod.leavePeriodId === change.leavePeriodId);
                        if (hasInErrorReason(leave.leaveCloseReason) ||
                            hasInErrorReason(period?.periodStatusReason)) {
                            return;
                        }
                        leaves.push({
                            lName: leave.lastName,
                            fName: leave.firstName,
                            fullName: this._getFullName(leave),
                            leaveId: leave.leaveId,
                            leaveStatus: leave.leaveStatus,
                            ssn: leave.taxIdentificationNumber,
                            eeId: leave.employeeId,
                            reportGroupNumber: period?.reportGroupNumber ?? "",
                            reportGroupName: period?.reportGroupName ?? "",
                            reportReason: CHANGE_ATTRIBUTE_NAME_MAP[change.changedAttributeNm] ?? NO_RECENT_LEAVE_CHANGES_MESSAGE,
                            LeavechgDate: change.changedDtTm,
                            lveRequestDt: leave.leaveRequestDt,
                            leaveStartDt: leave.leaveStartDt,
                            lveEndDt: leave.leaveEndDt,
                            lveReason: leave.leaveReason,
                            lveSchedType: period?.leaveScheduleTypeDesc ?? "",
                            rsHours: period?.reducedScheduleHours ?? "",
                            classification: this._getClassificationList(period),
                            lastDayWorked: leave.lastDateWorked,
                            lvePrdNumber: period?.leavePeriodNbr ?? "",
                            prdStartDt: period?.periodStartDt ?? "",
                            prdEndDt: period?.periodEndDt ?? "",
                            prdStatus: period?.periodStatus ?? "",
                            prdStatusReason: period?.periodStatusReason ?? "",
                            fitForDutyRelease: leave.fitForDutyReleaseDt,
                            benefitSpecialist: leave.benefitspecialistName,
                            managerName: leave.managerName,
                            protection: period?.leavePeriodProtection
                                ?.map((p) => p.protectionName)
                                .join(", ") || "",
                            protectionStatusDesc: period?.leavePeriodProtection
                                ?.map((p) => p.protectionStatusDesc)
                                .join(", ") || "",
                            receivedDt: leave.leaveReceivedDt,
                            rtwType: leave.RTWType,
                            rtwStatus: leave.RTWStatus,
                            fullTimeRTWDt: leave.fullTimeRTWDt,
                            partTimeRTWDt: leave.partTimeRTWDt,
                            status: leave.leaveStatus,
                            statusDt: leave.leaveStatusEffectiveDt,
                            closeReason: leave.leaveCloseReason,
                            workState: leave.workStateCd,
                            coverageType: leave.coverageType,
                        });
                    });
                }
            });
            return {
                searchResultMetadata,
                LeaveSearch: leaves,
            };
        };
        this._extractSearchMetadata = (response) => {
            return {
                startIndex: response.searchResultMetaData?.startIndex,
                totalResults: response.searchResultMetaData?.totalResults,
                itemsPerPage: response.searchResultMetaData?.itemsPerPage,
                timeTaken: response.searchResultMetaData?.resultMetadata?.timeTaken,
                links: response.searchResultMetaData?.resultMetaData?._links,
            };
        };
        this._getLeavePeriodProtection = (period) => {
            if (period && Array.isArray(period.leavePeriodProtection)) {
                return period.leavePeriodProtection
                    .map((p) => p.protectionName)
                    .join(", ");
            }
            return "";
        };
        this._getClassificationList = (period) => {
            const periodClassification = period?.leavePeriodClassification || [];
            return periodClassification.length > 0
                ? periodClassification.map((classification) => classification?.classificiationTypeDesc || "")
                    .filter((desc) => desc !== "")
                    .join(", ")
                : "";
        };
        this._getFullName = (person) => {
            const firstName = person?.firstName || "";
            const middleName = person?.middleName || "";
            const lastName = person?.lastName || "";
            if (!firstName && !middleName && !lastName) {
                return "";
            }
            return `${firstName} ${lastName} ${middleName}`.replace(/\s+/g, " ").trim();
        };
    }
}
export default new LeaveChanges();
